// extracted by mini-css-extract-plugin
export default {"container":"Jk8_09","icon":"DWk_Qj"};